import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import DefaultLayout from "@/layout/DefaultLayout.vue";
import store from "@/store";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Start",
    meta: {
      name: "Home",
    },
    redirect: { name: "Stats" },
    component: DefaultLayout,
    children: [
      {
        path: "statystyki",
        name: "Stats",
        meta: {
          name: "Statystyki",
        },
        component: () =>
          import(/* webpackChunkName: "stats" */ "@/views/stats/StatsView.vue"),
      },
      {
        path: "kalendarz",
        name: "Calendar",
        meta: {
          name: "Kalendarz",
        },
        component: () =>
          import(
            /* webpackChunkName: "calendar" */ "@/views/calendar/CalendarView.vue"
          ),
      },
      {
        path: "/oferty",
        name: "ClientList",
        meta: {
          name: "Oferty",
        },
        component: () =>
          import(
            /* webpackChunkName: "client" */ "@/views/client/ClientList.vue"
          ),
      },
      {
        path: "/oferty/:id",
        name: "ClientView",
        meta: {
          name: "Szczegóły oferty",
        },
        component: () =>
          import(
            /* webpackChunkName: "client" */ "@/views/client/ClientView.vue"
          ),
      },
      {
        path: "/platnosci",
        name: "ClientPaymentList",
        meta: {
          name: "Płatności",
        },
        component: () =>
          import(
            /* webpackChunkName: "client-payment" */ "@/views/client-payment/ClientPaymentList.vue"
          ),
      },
      {
        path: "/profile-mcs",
        name: "MasterList",
        meta: {
          name: "Profile MCS",
        },
        component: () =>
          import(
            /* webpackChunkName: "master" */ "@/views/master/MasterList.vue"
          ),
      },
      {
        path: "/profile-mcs/:id",
        name: "MasterView",
        meta: {
          name: "Szczegóły profilu MCS",
        },
        component: () =>
          import(
            /* webpackChunkName: "master" */ "@/views/master/MasterView.vue"
          ),
      },
      {
        path: "/logi-operacji",
        name: "EventList",
        meta: {
          name: "Rejestr zdarzeń",
        },
        component: () =>
          import(/* webpackChunkName: "event" */ "@/views/event/EventList.vue"),
      },
      {
        path: "/administratorzy",
        name: "UserList",
        meta: {
          name: "Administratorzy",
        },
        component: () =>
          import(/* webpackChunkName: "user" */ "@/views/user/UserList.vue"),
      },
      {
        path: "zmiana-hasla",
        name: "PasswordChange",
        meta: {
          name: "Zmiana hasła",
        },
        component: () =>
          import(
            /* webpackChunkName: "profile" */ "@/views/profile/PasswordChangeView.vue"
          ),
      },
    ],
  },
  {
    path: "/logowanie",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "auth" */ "@/views/auth/LoginView.vue"),
  },
  {
    path: "/resetowanie-hasla",
    name: "PasswordResetRequest",
    component: () =>
      import(
        /* webpackChunkName: "auth" */ "@/views/auth/PasswordResetRequestView.vue"
      ),
  },
  {
    path: "/resetowanie-hasla/:token",
    name: "PasswordReset",
    component: () =>
      import(
        /* webpackChunkName: "auth" */ "@/views/auth/PasswordResetView.vue"
      ),
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/views/error/NotFoundView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
router.beforeEach((to, from) => {
  if (
    !store.getters["auth/isAuthenticated"] &&
    to.name !== "Login" &&
    to.name !== "PasswordResetRequest" &&
    to.name !== "PasswordReset"
  ) {
    return { name: "Login" };
  }
  if (store.getters["auth/isAuthenticated"] && to.name === "Login") {
    return { name: "Stats" };
  }
});

export default router;
